module.exports = __webpack_public_path__ + "img/Paar_Cercle.2412cf4b.png";